import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { seoEnable } from 'reactApp/appHelpers/featuresHelpers/features/seoEnable';
import { historyPush } from 'reactApp/modules/router/router.module';
import { setCurrentSharedTab } from 'reactApp/modules/shared/shared.module';
import { getCurrentSharedTab } from 'reactApp/modules/shared/shared.selectors';
import { SharedTab } from 'reactApp/modules/shared/shared.type';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { PageTabMenu } from 'reactApp/ui/PageTabMenu/PageTabMenu';

import styles from './SharedTabs.css';

const TABS = [
    {
        value: SharedTab.links,
        name: 'Вы поделились',
    },
    {
        value: SharedTab.incoming,
        name: 'С вами поделились',
    },
    {
        value: SharedTab.autodelete,
        name: 'Автоудаляемые',
    },
    {
        value: SharedTab.indexed,
        name: 'В поисковиках',
    },
];

export const SharedTabs = memo(({ tab = SharedTab.links }: { tab?: SharedTab }) => {
    const dispatch = useDispatch();
    const currentTab = useSelector(getCurrentSharedTab);
    const isB2BUser = useSelector(UserSelectors.isB2BUser);

    const availableTabs = TABS.filter((tab) => {
        if (tab.value === SharedTab.autodelete) {
            return !isB2BUser;
        }

        if (tab.value === SharedTab.indexed) {
            return seoEnable && !IS_ONPREMISE && !isB2BUser;
        }

        return true;
    });

    useEffect(() => {
        if (currentTab === tab) {
            return;
        }

        dispatch(setCurrentSharedTab(tab));
    }, [currentTab, dispatch, tab]);

    const handleOnClickTab = useCallback(
        (value: SharedTab) => {
            dispatch(historyPush({ id: `shared/${value}` }));
            dispatch(setCurrentSharedTab(value));
        },
        [dispatch]
    );

    return (
        <div className={styles.root}>
            <PageTabMenu current={tab} tabs={availableTabs} onClick={handleOnClickTab} changeHash={false} />
        </div>
    );
});

SharedTabs.displayName = 'SharedTabs';
